import { render, staticRenderFns } from "./CommentsCards.vue?vue&type=template&id=12017fa4&"
import script from "./CommentsCards.vue?vue&type=script&lang=js&"
export * from "./CommentsCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports